import React from "react";
import { Button } from "../interfaces/common";
import Icon from "../../utils/Icon";

interface Props extends Button {
  style?: string;
  className?: string;
  icon?: string;
  id?: string;
  onClick?: any;
}
const Button = ({
  id = "",
  name,
  url,
  external,
  style,
  className,
  icon,
  onClick,
}: Props) => {
  if (!name) {
    return <></>;
  }

  if (onClick) {
    return (
      <button
        id={`${id}Button`}
        onClick={onClick}
        rel="noreferrer"
        className={`btn px-5 inline-block text-center py-4 bg-[--primary500] hover:bg-[--primary700] text-white font-bold  rounded-[--border-radius] cursor-pointer ${className}`}
      >
        <span className="flex gap-2" id={`${id}ButtonSpan`}>
          {name}
          <Icon nameIcon={icon} className={`text-2xl`} id={`${id}ButtonIcon`} />
        </span>
      </button>
    );
  }
  return (
    <a
      id={`${id}Button`}
      href={url}
      rel="noreferrer"
      target={external ? "_blank" : "_self"}
      className={`btn px-5 inline-block text-center py-4 bg-[--primary500] hover:bg-[--primary700] text-white font-bold  rounded-[--border-radius] cursor-pointer ${className}`}
    >
      <span className="flex gap-2" id={`${id}ButtonSpan`}>
        {name}
        <Icon nameIcon={icon} className={`text-2xl`} id={`${id}ButtonIcon`} />
      </span>
    </a>
  );
};

export default Button;
